import clone from "lodash/clone";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import map from "lodash/map";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    removeImageByIndex({ rootGetters, dispatch }, idx) {
      var modifiedArray = clone(rootGetters.editSlideArray);
      modifiedArray.splice(idx, 1);
      dispatch("saveSlideArray", modifiedArray, { root: true });
    },
    removeImagesByIdsArray({ rootGetters, dispatch }, idsArray) {
      // Remove from the array by an array of indexes.
      console.log("removeImagesByIdsArray", idsArray);
      var modifiedArray = cloneDeep(rootGetters.editSlideArray);
      modifiedArray = filter(modifiedArray, s => {
        return !idsArray.includes(s.id);
      });
      dispatch("saveSlideArray", modifiedArray, { root: true });
    },
    updateImageIndexToCurrentTime({ rootGetters, rootState, dispatch }, idx) {
      var modifiedArray = clone(rootGetters.editSlideArray);
      var currentTime = rootState.editorAudioReference.currentTime;
      modifiedArray[idx].timing = currentTime * 1000;
      // Re-sort the array.
      modifiedArray = sortBy(modifiedArray, "timing");
      dispatch("saveSlideArray", modifiedArray, { root: true });
    },
    updateImageData({ rootGetters, dispatch }, imageObject) {
      console.log("updateImageData");
      var modifiedArray = clone(rootGetters.editSlideArray);
      // find the item idx matching timing.
      var idx = findIndex(modifiedArray, ["timing", imageObject.timing]);
      console.log("Index:", idx);
      if (idx > -1) {
        modifiedArray[idx] = imageObject;
        console.log("imageObject", imageObject);
      }
      dispatch("saveSlideArray", modifiedArray, { root: true });
    },
    addImageAtCurrentTime({ rootGetters, rootState, dispatch }, image) {
      var modifiedArray = clone(rootGetters.editSlideArray);
      var currentTime = rootState.editorAudioReference.currentTime;
      var timing = currentTime * 1000;
      if (image.type == "video") {
        var deployedVideoFiles = filter(
          rootState.currentShowDetails,
          (s, k) => {
            if (k.startsWith("staticMp4Deployed_")) {
              return s;
            }
          }
        );
        var video = find(deployedVideoFiles, { filename: image.filename });
        modifiedArray.push({
          file: image.filename,
          source_id: image.source_id,
          name: image.name,
          caption: "",
          timing: timing,
          type: "video",
          source_url: `https://cdn3.soundslides.com/video/${video.source_id}/${
            video.filename
          }`,
          source_aspect_ratio: video.displayaspectratio,
          duration: video.duration,
          inpoint: timing / 1000,
          keep_sync: true,
          transition_time_in:
            rootState.currentShowDetails.data.displaySettings
              .globalTransitionTime / 2,
          transition_time_out:
            rootState.currentShowDetails.data.displaySettings
              .globalTransitionTime / 2,
          main_volume: 1,
          slide_volume: 1
        });
      } else {
        modifiedArray.push({
          caption: "",
          source_id: image.source_id,
          file: image.filename,
          name: image.name,
          timing: timing
        });
      }

      // Re-sort the array.
      modifiedArray = sortBy(modifiedArray, "timing");
      dispatch("saveSlideArray", modifiedArray, { root: true });
    },
    updateImageByIdToTime({ rootGetters, dispatch, rootState }, obj) {
      //console.log("updateImageByIdToTime");
      var image_id = obj.image_id;
      var time = obj.time;
      var sortAtEnd = obj.sortAtEnd;
      var modifiedArray = cloneDeep(rootGetters.editSlideArray);
      var image = find(modifiedArray, { id: image_id });
      image.timing = time * 1000;
      image.unpinned = false;
      // Re-sort the array.
      if (sortAtEnd === true) {
        modifiedArray = sortBy(modifiedArray, "timing");
      }

      var imageIndex = findIndex(modifiedArray, { id: image_id });

      if (
        rootState.currentShowDetails.data.displaySettings.globalTimelineAutoPin
      ) {
        modifiedArray = map(modifiedArray, (s, idx) => {
          if (idx < imageIndex) {
            s.unpinned = false;
          }
          return s;
        });
      }
      dispatch("saveSlideArray", modifiedArray, { root: true });
    }
  }
};
